var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 112,
    viewBox: "0 0 127 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5728 27.3481C20.2025 12.5048 32.686 5.22112 46.7352 1.99961C68.2408 -2.93172 88.6063 1.0288 107.31 16.4402C114.641 22.4808 120.903 30.0654 124.735 40.6055C126.653 45.8816 127.543 51.4051 126.655 57.1843C125.203 66.633 119.553 72.7309 111.624 73.7744C102.122 75.025 93.5879 70.9442 85.6519 64.8139C78.4656 59.2628 71.7474 52.668 64.6975 46.7951C56.42 39.8995 47.4676 35.2056 37.5986 34.4173C23.8669 33.3204 12.5511 40.3222 3.06648 53.0667C2.2155 54.2102 1.40018 55.3998 0.558494 56.5555C0.513405 56.6175 0.376944 56.5635 6.10352e-05 56.5635C1.64384 45.6565 5.09769 36.0271 10.5728 27.3481Z",
    fill: "#6F00E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.22 85.6902C116.909 83.0111 119.485 80.7763 126.993 71.2311C127.116 73.8829 125.665 79.7331 123.808 84.1886C118.285 97.4359 109.584 104.998 98.7826 108.391C81.4624 113.83 65.0795 111.074 50.2574 97.1984C45.4421 92.6906 41.4631 87.0647 39.6513 79.3077C37.2101 68.8557 41.8402 59.9322 50.0544 59.0991C55.4377 58.5532 60.4945 60.2865 65.1043 63.6964C69.989 67.3095 74.6478 71.4851 79.3125 75.6019C86.3794 81.8386 93.8191 86.6801 102.5 86.7924C105.018 86.825 107.541 86.1088 110.22 85.6902Z",
    fill: "#FF5628"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1611,
    cy: 93.3273,
    r: 17.5,
    transform: "rotate(-1.03775 18.1611 93.3273)",
    fill: "#626161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fc4993c5d2e14e928545db4e6611399e.svg";
export { ForwardRef as ReactComponent };